import { motion } from "framer-motion";
import { Sun } from "lucide-react";

/**
 * Empire — Lunch Special callout
 * Subtle gold-accent strip placed directly under the hero,
 * above the first content section. Editorial, not promotional.
 */
export default function LunchSpecial() {
    return (
        <section
            data-testid="lunch-special-banner"
            aria-label="Lunch special"
            className="relative bg-charcoal border-y border-cream/[0.08]"
        >
            <div className="empire-container py-5 md:py-6">
                <motion.div
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                    className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-6"
                >
                    <div className="flex items-center gap-4 min-w-0">
                        <span
                            aria-hidden
                            className="inline-flex h-9 w-9 items-center justify-center border border-gold/40 text-gold shrink-0"
                        >
                            <Sun size={14} strokeWidth={1.4} />
                        </span>
                        <p className="text-cream/90 text-[12px] md:text-[13px] tracking-[0.18em] uppercase font-light leading-tight">
                            <span className="text-gold font-medium">
                                Lunch Special
                            </span>
                            <span className="text-cream/30 mx-3">·</span>
                            Mon – Fri
                            <span className="text-cream/30 mx-3">·</span>
                            11AM – 2PM
                            <span className="text-cream/30 mx-3">·</span>
                            <span className="text-cream">Starting at $8.99</span>
                        </p>
                    </div>
                    <a
                        href="/menu"
                        data-testid="lunch-special-cta"
                        className="empire-link inline-flex items-center gap-2 text-[10px] md:text-[11px] uppercase tracking-[0.22em] whitespace-nowrap self-start md:self-auto"
                    >
                        See Lunch Menu
                        <span aria-hidden>→</span>
                    </a>
                </motion.div>
            </div>
        </section>
    );
}
